import { CalendarHeart } from "lucide-react";
import { DORIE_URL } from "../constants";
import { Reveal } from "./Reveal";

const TREATMENTS = [
    {
        name: "مساج طبي عميق",
        desc: "جلسة مساج عميقة تركّز على مناطق الشد والتعب في الجسم.",
        price: "200 ₪",
        img: "https://images.unsplash.com/photo-1639162906614-0603b0ae95fd?auto=format&fit=crop&w=800&q=70",
    },
    {
        name: "مساج مدمج",
        desc: "مساج مدمج مع كاسات الهواء أو الإبر الصينية، وفق نوع الجلسة والاحتياج.",
        price: "350 ₪",
        img: "https://images.pexels.com/photos/7239303/pexels-photo-7239303.jpeg?auto=compress&cs=tinysrgb&w=800",
    },
    {
        name: "مساج استرخاء",
        desc: "جلسة مساج للاسترخاء مع الحجارة الساخنة أو كمادات الأعشاب.",
        price: "300 ₪",
        img: "https://images.unsplash.com/photo-1600334089648-b0d9d3028eb2?auto=format&fit=crop&w=800&q=70",
    },
    {
        name: "مساج للحوامل",
        desc: "جلسة لطيفة ومريحة مصممة بما يتناسب مع احتياجات الحامل.",
        price: "200 ₪",
        img: "https://images.unsplash.com/photo-1457342813143-a1ae27448a82?auto=format&fit=crop&w=800&q=70",
    },
    {
        name: "مساج للأطفال",
        desc: "جلسة لطيفة تراعي عمر الطفل واحتياجاته.",
        price: "200 ₪",
        img: "https://images.unsplash.com/photo-1537673156864-5d2c72de7824?auto=format&fit=crop&w=800&q=70",
    },
    {
        name: "جلسة إبر صينية",
        desc: "جلسة مخصصة وفق الاحتياج وبعد تقييم أولي.",
        price: "200–400 ₪",
        img: "https://images.pexels.com/photos/8312859/pexels-photo-8312859.jpeg?auto=compress&cs=tinysrgb&w=800",
    },
    {
        name: "الحجامة",
        desc: "جلسة حجامة في مساحة هادئة مع اهتمام بالنظافة والراحة.",
        price: "250 ₪",
        img: "https://images.unsplash.com/photo-1598555748505-ccca0d9b9f7b?auto=format&fit=crop&w=800&q=70",
    },
    {
        name: "الرفلكسولوجيا",
        desc: "جلسة تعتمد على العمل على نقاط محددة في القدمين لدعم الاسترخاء والتوازن.",
        price: "250 ₪",
        img: "https://images.unsplash.com/photo-1706795033796-0057e5864e6d?auto=format&fit=crop&w=800&q=70",
    },
];

export const Treatments = () => (
    <section
        id="treatments"
        data-testid="treatments-section"
        className="scroll-mt-24 pt-10 pb-20 lg:pt-14 lg:pb-28"
    >
        <div className="mx-auto max-w-7xl px-5 lg:px-10">
            <Reveal className="max-w-2xl">
                <p className="mb-3 text-sm font-bold text-miam-rose">علاجاتنا</p>
                <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-miam-dark">
                    علاجات <span className="italic text-miam-rose">ميام</span>
                </h2>
                <p className="mt-5 text-base text-miam-muted leading-relaxed">
                    اختاري العلاج الذي يناسب احتياجات جسدك، أو تواصلي مع مياسة
                    لمساعدتك في اختيار الجلسة المناسبة.
                </p>
            </Reveal>

            <div className="mt-14 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
                {TREATMENTS.map(({ name, desc, price, img }, i) => (
                    <Reveal key={name} delay={0.05 * (i % 4)}>
                        <article
                            data-testid={`treatment-card-${i}`}
                            className="group flex h-full flex-col overflow-hidden rounded-2xl bg-white soft-shadow-sm transition-[transform,box-shadow] duration-300 hover:-translate-y-1.5 hover:soft-shadow"
                        >
                            <div className="relative h-44 overflow-hidden">
                                <img
                                    src={img}
                                    alt={`علاج ${name} في ميام`}
                                    data-testid={`treatment-image-${i}`}
                                    loading="lazy"
                                    className="h-full w-full object-cover transition-transform duration-700 ease-out group-hover:scale-105"
                                />
                                <div
                                    className="pointer-events-none absolute inset-0 bg-miam-dark/20 transition-opacity duration-500 group-hover:opacity-0"
                                    aria-hidden="true"
                                />
                            </div>
                            <div className="flex flex-1 flex-col p-6">
                                <h3 className="font-heading text-xl font-bold text-miam-dark">
                                    {name}
                                </h3>
                                <p className="mt-2.5 flex-1 text-sm font-medium text-miam-dark/75 leading-relaxed">
                                    {desc}
                                </p>
                                <p
                                    data-testid={`treatment-price-${i}`}
                                    className="mt-4 font-heading text-xl font-bold text-miam-green-dark"
                                >
                                    {price}
                                </p>
                                <a
                                    href={DORIE_URL}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    data-testid={`treatment-book-button-${i}`}
                                    className="mt-4 inline-flex items-center justify-center gap-2 rounded-full border-2 border-miam-green px-5 py-2.5 text-sm font-bold text-miam-green-dark transition-[background-color,color] duration-300 hover:bg-miam-green hover:text-white"
                                >
                                    <CalendarHeart className="h-4 w-4" aria-hidden="true" />
                                    احجزي موعداً
                                </a>
                            </div>
                        </article>
                    </Reveal>
                ))}
            </div>
        </div>
    </section>
);
